import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    menuList: [],
    token: sessionStorage.getItem("external-token") || "", // 从 sessionStorage 初始化
    userInfo: {},
  },
  getters: {},
  mutations: {
    SET_MENU_LIST(state, data) {
      state.menuList = data;
    },
    SET_TOKEN(state, token) {
      state.token = token;
      sessionStorage.setItem("external-token", token); // 同步到 sessionStorage
    },
    SET_USER_INFO(state, info) {
      state.userInfo = info;
      console.log(info);
      sessionStorage.setItem("external-userInfo",info)
    },
    CLEAR_AUTH(state) {
      state.token = "";
      state.userInfo = {};
      state.menuList = []; // 同时清空菜单
      sessionStorage.removeItem("external-token");
      sessionStorage.removeItem("external-userInfo");

      // 动态导入 router 并重置路由，避免循环依赖
      import("@/router").then(({ resetRouter }) => {
        resetRouter();
      }).catch(err => {
        console.error("重置路由失败", err);
      });
    },
  },
  actions: {
    // 登出 action
    logout({ commit }) {
      commit("CLEAR_AUTH");
      // 可选：跳转登录页，但通常由组件在调用后自行跳转
    },
  },
  modules: {},
});